<!-- @format -->

<fudis-dialog [size]="'xs'" *transloco="let t">
  <fudis-heading fudisDialogTitle [level]="2" [variant]="'lg'">
    {{ t("TIMELINE.MULTI_PERIOD_TIMING.DIALOG_TITLE") }}
  </fudis-heading>
  <fudis-dialog-content>
    <fudis-body-text class="fudis-mb-md">{{ t("TIMELINE.MULTI_PERIOD_TIMING.DIALOG_DESCRIPTION") }}</fudis-body-text>
    <fudis-body-text class="fudis-mb-md">
      <transloco
        [key]="'TIMELINE.MULTI_PERIOD_TIMING.DIALOG_PERIODS_INTRO'"
        [params]="{ name: data.studyName, credits: data.credits | creditRange }" />
    </fudis-body-text>
    @for (studyTerm of data.studyTerms; track $index) {
      <fudis-body-text class="fudis-mb-none">{{ studyTerm.startYear }} {{ studyTerm.name }}</fudis-body-text>
      <ul class="fudis-pl-lg fudis-mb-sm">
        @for (periodName of studyTerm.periodNames; track $index) {
          <li>{{ periodName }}</li>
        }
      </ul>
    }
  </fudis-dialog-content>
  <fudis-dialog-actions>
    <fudis-button fudisDialogClose [label]="t('SIS_COMPONENTS.BUTTON.CLOSE')" />
  </fudis-dialog-actions>
</fudis-dialog>
